var _style, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHxCa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bandera",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.7 453.2",
    style: {
      enableBackground: "new 0 0 511.7 453.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000122715114036650538200000002631088795070915234_);fill:#E81E25;}\n\t.st1{clip-path:url(#SVGID_00000122715114036650538200000002631088795070915234_);fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.6,0H149.3c-15.1,0-29.1,8.1-36.7,21.2L6,205.4c-7.6,13.1-7.6,29.4,0,42.5l106.6,184.2c7.6,13.1,21.6,21.2,36.7,21.2 h213.4c15.1,0,29.1-8.1,36.7-21.2L506,247.9c7.6-13.1,7.6-29.4,0-42.5L399.4,21.2C391.8,8.1,377.8,0,362.6,0z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M118.6,432.8L8.7,242.5c-5.7-9.8-5.7-22,0-31.8L118.6,20.4c5.7-9.8,16.2-15.9,27.6-15.9h219.7 c11.4,0,21.9,6.1,27.5,15.9l109.9,190.3c5.7,9.8,5.7,22,0,31.8L393.4,432.8c-5.7,9.8-16.2,15.9-27.5,15.9H146.1 C134.8,448.7,124.3,442.7,118.6,432.8L118.6,432.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023973717316113099840000002380210306735317943_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000023973717316113099840000002380210306735317943_)",
      fill: "#E81E25"
    },
    width: 120.4,
    height: 453.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.2,
    style: {
      clipPath: "url(#SVGID_00000023973717316113099840000002380210306735317943_)",
      fill: "#E81E25"
    },
    width: 120.4,
    height: 453.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.4,
    style: {
      clipPath: "url(#SVGID_00000023973717316113099840000002380210306735317943_)",
      fill: "#FFFFFF"
    },
    width: 270.9,
    height: 453.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000023973717316113099840000002380210306735317943_)",
      fill: "#E81E25"
    },
    d: "M255.8,113L238,147.5 c-2,3.8-5.6,3.4-9.2,1.3l-12.9-6.9l9.6,53c2,9.7-4.4,9.7-7.6,5.5l-22.4-26.1l-3.6,13.3c-0.4,1.7-2.2,3.6-5,3.1l-28.3-6.2l7.4,28.2 c1.6,6.3,2.8,8.9-1.6,10.6l-10.1,4.9l48.8,41.3c1.9,1.6,2.9,4.4,2.2,6.9l-4.3,14.6c16.8-2,31.9-3.9,48.6-5.9c1.5,0,4,1.3,4,3.1 l-2.2,53.5h8.2l-1.3-53.4c0-1.7,2.3-3.2,3.7-3.2c16.8,2,31.9,3.9,48.7,5.9l-4.3-14.6c-0.7-2.6,0.3-5.3,2.2-6.9l48.8-41.3l-10.1-4.9 c-4.5-1.6-3.2-4.3-1.6-10.6l7.5-28.2l-28.4,6.2c-2.8,0.4-4.6-1.4-5-3.1l-3.6-13.3l-22.4,26.1c-3.2,4.2-9.6,4.2-7.6-5.5l9.6-53 l-12.8,6.9c-3.6,2.1-7.2,2.5-9.2-1.3L255.8,113L255.8,113z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHxCa);
export default __webpack_public_path__ + "static/media/hx-ca.c0deb85a8060a32b456a0a3ff39d06dc.svg";
export { ForwardRef as ReactComponent };